/*
ProgressBar — composant pur HTML, mirror Android Material 3
`LinearProgressIndicator` utilisé dans `ProfileScreen.kt:ProgressionCard`
(Android v1.2.0).

API : `renderProgressBar({label, value, total})` retourne une
string HTML. Masque la barre entièrement si `value <= 0 || total <= 0`
(parité Android `ProgressBar:514`).

Layout :
- Row label + « X / Y · Z % » alignement right.
- Barre 12 px de haut, fond surface-variant, fill primary, transition
  width 240ms ease.

CSS classes : `.m3-progress-bar`, `.m3-progress-bar-fill`,
`.progression-bar-row`. Définies dans app.css.
*/

const kFrenchNumber = new Intl.NumberFormat('fr-FR')  // séparateur de milliers pour les compteurs

export interface ProgressBarProps
{
	label: string
	value: number
	total: number
	metricId?: string  // si présent, expose data-metric pour le long-press histogramme (HistorySheet)
}

export function renderProgressBar(inProps: ProgressBarProps): string
{
	if (inProps.value <= 0 || inProps.total <= 0) return ''
	const vClamped = Math.min(inProps.value, inProps.total)
	const vPct = Math.round((vClamped / inProps.total) * 100)
	const vCounter = `${kFrenchNumber.format(inProps.value)} / ${kFrenchNumber.format(inProps.total)} · ${vPct} %`
	const vMetricAttr = inProps.metricId ? ` data-metric="${escapeHtml(inProps.metricId)}"` : ''
	return `
		<div class="progression-bar"${vMetricAttr}>
			<div class="progression-bar-row">
				<span class="progression-bar-label">${escapeHtml(inProps.label)}</span>
				<span class="progression-bar-counter">${escapeHtml(vCounter)}</span>
			</div>
			<div class="m3-progress-bar">
				<div class="m3-progress-bar-fill" style="width:${vPct}%"></div>
			</div>
		</div>
	`
}

function escapeHtml(inText: string): string
{
	return inText
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
}
